
define('modules/application/wizard/classes/kits/automationSimpleKits',["app",

// Libs
"backbone",

//Classes
"../kits"],

function(app, Backbone, kits) {

  var kitModel = kits.KitModel.extend({

    initialize                        : function() {
      this.fetchProducts();
      this.fetchComponentsPackages();
      window.BticinoS4B.eventAggregator.bind("connectToKit", this.connectItems, this);

      var packages       = this.get("specialVars").packages,
          packagesLength = packages.length,
          maxZoneNumber  = 0,
          j              = 0;

      for(j=0; j<packagesLength; j++)
      {
        if (packages[j].specialVars && packages[j].specialVars.maxZoneNumber)
        {
          maxZoneNumber = packages[j].specialVars.maxZoneNumber;
          break;
        }
      }

      this.set("maxZoneNumber", maxZoneNumber);
    },
    // insertThisKit                     : function(kitCode) {
    //   var value         = this.findValueFromProductCode(kitCode);
    //   var finalPackage, dataToReturn = {};

    //   if (value)
    //   {
    //     dataToReturn.packages = [finalPackage];
    //     this.kitsFetchedEventHandler(dataToReturn);
    //     this.confirmSelectedKit();
    //   }
    // },

    addKit                : function(_silent) {
      var added = this.get("added");
      var silent= false;

      if (_silent)
        silent = _silent;

      if (!added)
      {
        var kitPackages = this.get("specialVars") ? this.get("specialVars").packages : [];

        var zoneNumberChangedEventHandler  =  function(newZoneNumber) {
          this.addToZone = newZoneNumber;
        };

        var requestRefresh                 = function() {
          this.trigger("render:requested");
        };

        for(var i=0, packagesLength = kitPackages.length; i<packagesLength; i++)
        {
          if (!silent || kitPackages[i].name==="powerSupply" || kitPackages[i].name==="keyCover" || kitPackages[i].name==="configurators")
          {
            kitPackages[i].kitsEventAggregator = _.extend({}, Backbone.Events);
            kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", zoneNumberChangedEventHandler, kitPackages[i]);
            kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", requestRefresh, this);
            window.BticinoS4B.eventAggregator.trigger(kitPackages[i].name+":addedFromKit", kitPackages[i]);
          }
        }

        this.set("added", true);
        window.BticinoS4B.eventAggregator.trigger("kit:added");
        this.trigger("render:requested");
      }
      else
        this.removeCurrentKit();

      this.trigger("render:requested");
      this.trigger("updateViews");
    },

    isPossibleToAdd           : function() {
      return true;
    }
  });

  var automationSimpleKits = _.extend({}, kits, {

    Model: kits.Model.extend({
      defaults: _.extend({
        updateAutocalculatedElements: false,
        wizardChoiceId              : 849,
        nrOfLights                  :   6,
        minNrOfLights               :   0,
        nrOfRollingShutters         :   3,
        minNrOfRollingShutters      :   0,
        nrOfCommands                :   1,
        minNrOfCommands             :   1,
        nrAddress                   :   0,
        maxNrAddress                :  81,
        defaultActuatorLights       :   3,
        nrOfActuatorLights          :   3,
        defaultActuatorShutters     :   3,
        nrOfActuatorShutters        :   3,
        dictionary                  : [
            {
              productCode            : "MHKIT1013",
              packageClassId         : "22100"
            },
            {
              productCode            : "MHKIT4013",
              packageClassId         : "22101"
            },
            {
              productCode            : "MHKIT1114",
              packageClassId         : "1623"
            }
          ]
        }, kits.Model.defaults),
        // addConstructor                    : function() {
        //   this.kitModel = kitModel;
        // },

        initialize                : function() {
          kits.Model.prototype.initialize.apply(this);
          this.addConstructor();
          window.BticinoS4B.eventAggregator.bind("connectToKit", this.connectItems, this);
          this.calculateNrOfAddress();
        },
        
        calculateNrOfAddress: function(){
          var nrOfLights          = this.get('nrOfLights'),
              nrOfRollingShutters = this.get('nrOfRollingShutters'),
              nrOfActuatorLights,
              nrOfActuatorShutters;

          nrOfActuatorLights   = Math.ceil(nrOfLights / 2);
          nrOfActuatorShutters = nrOfRollingShutters;

          this.set('nrOfActuatorLights', nrOfActuatorLights);
          this.set('nrOfActuatorShutters', nrOfActuatorShutters);
        },

        checkMinLoad: function(){
          var nrOfLights          = this.get('nrOfLights'),
              nrOfRollingShutters = this.get('nrOfRollingShutters'),
              nrOfKitActuators    = this.get('defaultActuatorLights') + this.get('defaultActuatorShutters');

          if ((Math.ceil(nrOfLights/2) + nrOfRollingShutters) < nrOfKitActuators) {
            alert('Attenzione: il numero di carichi selezionati è inferiore a quello gestibile dagli attuatori del kit.');
          }
        },

        isPossibleToAdd: function(loadType, value) {
          this.calculateNrOfAddress();
          return true;
        },

        isPossibleToRemove: function(loadType, value) {
          switch (loadType) {
              case 'lights':
                  return ( this.get('minNrOfLights') <= (value-1) ) ? true : false;
              case 'rollingShutters':
                  return ( this.get('minNrOfRollingShutters') <= (value-1) ) ? true : false;
              case 'commands':
                  return ( this.get('minNrOfCommands') <= (value-1) ) ? true : false;
          }
          this.calculateNrOfAddress();
        },

        IncrementNrOfLights: function() {
          var newValue = this.get('nrOfLights');
          if (this.isPossibleToAdd('lights', newValue)) {
            newValue = newValue + 1;
            this.set('nrOfLights', newValue);
          }
          return newValue;
        },

        DecrementNrOfLights: function() {
          var newValue = this.get('nrOfLights');
          if (this.isPossibleToRemove('lights', newValue)){
            newValue = newValue - 1;
            this.set('nrOfLights', newValue);
          }
          else {
            alert('Raggiunto il numero minimo di elementi selezionabili');
          }
          this.checkMinLoad();
          return newValue;
        },

        IncrementNrOfRollingShutters: function() {
          var newValue = this.get('nrOfRollingShutters');
          if (this.isPossibleToAdd('rollingShutters', newValue)) {
            newValue = newValue + 1;
            this.set('nrOfRollingShutters', newValue);
          }
          return newValue;
        },

        DecrementNrOfRollingShutters: function() {
          var newValue = this.get('nrOfRollingShutters');
          if (this.isPossibleToRemove('rollingShutters', newValue)) {
            newValue = newValue - 1;
            this.set('nrOfRollingShutters', newValue);
          }
          else {
            alert('Raggiunto il numero minimo di elementi selezionabili');
          }
          this.checkMinLoad();
          return newValue;
        },

        IncrementNrOfCommands: function() {
          var newValue = this.get('nrOfCommands');
          if (this.isPossibleToAdd('commands', newValue)) {
            newValue = newValue + 1;
            this.set('nrOfCommands', newValue);
          }
          return newValue;
        },

        DecrementNrOfCommands: function() {
          var newValue = this.get('nrOfCommands');
          if (this.isPossibleToRemove('commands', newValue)) {
            newValue = newValue - 1;
            this.set('nrOfCommands', newValue);
          }
          else {
            alert('Raggiunto il numero minimo di elementi selezionabili');
          }
          return newValue;
        },

        // insertThisKit                     : function(kitCode) {
        //   var value         = this.findValueFromProductCode(kitCode);
        //   var finalPackage, dataToReturn = {};

        //   if (value)
        //   {
        //     dataToReturn.packages = [finalPackage];
        //     this.kitsFetchedEventHandler(dataToReturn);
        //     this.confirmSelectedKit();
        //   }
        // }
      })
    });

  // Required, return the module for AMD compliance
  return automationSimpleKits;
});